const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/customisation/personalised-video/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { graphql } from 'react-relay';
export const PersonalisedVideoQuery = graphql`
  fragment personalisedVideo_Settings_Fragment on ZnglyInfo_Znglyinfo {
    pvImages {
      image {
        id
        title
        mediaItemUrl
      }
    }
  }
`;
export const Route = createFileRoute('/dash/settings/customisation/personalised-video/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});